import { combineReducers } from 'redux'
import { gameReducer } from './gameReducer'
import { playersReducer } from './playersReducer'
import { roundReducer } from './roundReducer'
import { cardsReducer } from "./cardsReducer"
import { localFirestoreReducer } from './localFirestoreReducer'
import { localFirebaseReducer } from './localFirebaseReducer'

const rootReducer = combineReducers({
	game: gameReducer,
	players: playersReducer,
	round: roundReducer,
	cards: cardsReducer,
	firestore: localFirestoreReducer,
	firebase: localFirebaseReducer,
})

export default rootReducer
